import { render, staticRenderFns } from "./ErrorBannerContainer.vue?vue&type=template&id=32a79b6c"
import script from "./ErrorBannerContainer.vue?vue&type=script&lang=js"
export * from "./ErrorBannerContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports